export default __webpack_public_path__ + "static/media/linkToHowItWorks.2c255a71.png";